<script lang="ts" setup>
import { SidebarHeader } from "@/@types/dtos/sidebar.types";
import usePermission from "@/app/composables/usePermission";
import SidebarPathItem from "./SidebarPathITem.vue";

const props = defineProps<{
  header: SidebarHeader;
}>();

const { userHasPermission } = usePermission();
const shouldShowHeader = props.header.paths.some((path) =>
  userHasPermission(path.permission)
);
</script>
<template>
  <template v-if="header.header && shouldShowHeader">
    <hr class="navbar-divider" />
    <h6 class="navbar-heading mb-0">{{ header.header }}</h6>
  </template>
  <ul class="navbar-nav">
    <SidebarPathItem
      v-for="(path, index) in header.paths"
      :path="path"
      :key="index"
      :showItem="userHasPermission(path.permission)"
    />
  </ul>
</template>
